import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Quota } from '../models';

@Injectable({ providedIn: 'root' })
export class QuotaService extends EntityCollectionServiceBase<Quota> {
    [name: string]: any;
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('Quota', serviceElementsFactory);
    }
}
